import React, { useCallback } from 'react';

import { HistoryOfChangesItem } from 'pages/item/v2/types/history-of-changes';
import getScoreSeverity from 'utils/get-score-severity';
import isEmpty from 'utils/is-empty';

import ScorePane from '../ScorePane';
import TrendTooltip from '../TrendTooltip';

interface Props {
    cvss2?: {
        cvssV2?: Record<string, string | number>;
    };
}

const Cvss2: React.FC<Props> = ({ cvss2 }) => {
    const getChart = useCallback((data: HistoryOfChangesItem[]) => {
        if (data.every(({ changes }) => 'cvss2' in changes === false)) return null;

        return data.reduce((output, { version, published, changes }) => {
            const score = changes.cvss2?.cvssV2?.baseScore ?? output.at(-1)?.score ?? 0;
            output.push({ version, score, published });
            return output;
        }, [] as { score: number; version: number; published: Date }[]);
    }, []);

    if (!cvss2 || isEmpty(cvss2) || !cvss2.cvssV2 || isEmpty(cvss2.cvssV2)) {
        return null;
    }

    const score = Number(cvss2.cvssV2.baseScore ?? -1);
    const vector = String(cvss2.cvssV2.vectorString ?? '');

    return (
        <TrendTooltip getChart={getChart} title="CVSS2 score statistics">
            <ScorePane
                score={score}
                severity={getScoreSeverity(score)}
                name="CVSS2"
                vector={vector}
                vectorItems={{
                    accessVector: cvss2.cvssV2.accessVector,
                    accessComplexity: cvss2.cvssV2.accessComplexity,
                    authentication: cvss2.cvssV2.authentication,
                    confidentialityImpact: cvss2.cvssV2.confidentialityImpact,
                    integrityImpact: cvss2.cvssV2.integrityImpact,
                    availabilityImpact: cvss2.cvssV2.availabilityImpact
                }}
            />
        </TrendTooltip>
    );
};

export default Cvss2;
